var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"license-status",class:( _obj = {
    'tw-border tw-border-solid tw-px-4 tw-py-2 tw-rounded-md tw-text-base tw-opacity-100 tw-flex tw-items-center tw-justify-center tw-cursor-pointer': true
  }, _obj[_vm.status] = true, _obj )},[_c('c-icon',{staticClass:"tw-mr-2",attrs:{"icon":"check"}}),_vm._v("\n  "+_vm._s(_vm.description)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }